module.exports = __webpack_public_path__ + "img/16d011-28.f1aa1f57.jpg";